import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table'
import { flexRender } from '@tanstack/react-table'
import { ChevronsUpDown } from 'lucide-react'
import { TableVirtuoso } from 'react-virtuoso'

import type { Table as TanStackTable } from '@tanstack/react-table'

interface DataTableProps {
	table: TanStackTable<any>
}

export function DataTable({ table }: DataTableProps) {
	const { rows } = table.getRowModel()

	if (!rows.length) {
		return (
			<div className="relative">
				<Table>
					<TableHeader>
						{table.getHeaderGroups().map((headerGroup) => (
							<TableRow key={headerGroup.id}>
								{headerGroup.headers.map((header) => {
									return (
										<TableHead key={header.id}>
											{header.isPlaceholder ? null : (
												<div
													{...{
														className: header.column.getCanSort()
															? 'cursor-pointer select-none flex items-center gap-1'
															: '',
														onClick: header.column.getToggleSortingHandler(),
													}}
												>
													{flexRender(header.column.columnDef.header, header.getContext())}
													{header.column.getCanSort() && <ChevronsUpDown className="h-4 w-4" />}
												</div>
											)}
										</TableHead>
									)
								})}
							</TableRow>
						))}
					</TableHeader>
					<TableBody>
						<TableRow>
							<TableCell colSpan={table.getAllColumns().length} className="h-24 text-center">
								No results.
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</div>
		)
	}

	return (
		<div style={{ height: '100%' }}>
			<TableVirtuoso
				data={rows}
				components={{
					Table: ({ style, ...props }) => <Table {...props} style={{ ...style, width: '100%' }} />,
					TableHead: TableHeader as any,
					TableBody: TableBody as any,
					TableRow: ({ item: _item, ...props }) => (
						<TableRow {...props} data-state={_item.getIsSelected() && 'selected'} />
					),
				}}
				fixedHeaderContent={() => {
					return table.getHeaderGroups().map((headerGroup) => (
						<TableRow key={headerGroup.id}>
							{headerGroup.headers.map((header) => {
								return (
									<TableHead key={header.id}>
										{header.isPlaceholder ? null : (
											<div
												{...{
													className: header.column.getCanSort()
														? 'cursor-pointer select-none flex items-center gap-1'
														: '',
													onClick: header.column.getToggleSortingHandler(),
												}}
											>
												{flexRender(header.column.columnDef.header, header.getContext())}
												{header.column.getCanSort() && <ChevronsUpDown className="h-4 w-4" />}
											</div>
										)}
									</TableHead>
								)
							})}
						</TableRow>
					))
				}}
				itemContent={(_index, row) => {
					return row
						.getVisibleCells()
						.map((cell) => (
							<TableCell key={cell.id}>
								{flexRender(cell.column.columnDef.cell, cell.getContext())}
							</TableCell>
						))
				}}
			/>
		</div>
	)
}
